import { UAParser } from 'ua-parser-js';
import { Component, OnDestroy } from '@angular/core';
import { WizardPageComponent } from '../../../../core/wizard/wizard-page-component';
import type { WelcomeWizard } from '../welcome-wizard';
import { Observable, of } from 'rxjs';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { KeyIndicatorType } from '../../../../core/user-preferences/key-indicator-type.enum';
import * as _ from 'lodash';
import { HitTrackingService } from '../../../../core/hit-tracking/hit-tracking.service';
import { USER_TRACKING_ACTION_DESCRIPTIONS, USER_TRACKING_ACTIONS, USER_TRACKING_SOURCES } from 'src/app/core/constants/user-tracking.constants';
import { UserPreferencesService } from 'src/app/core/user-preferences/user-preferences.service';
import { map } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'mtn-welcome-wizard-key-indicator-page',
  templateUrl: './welcome-wizard-key-indicator-page.component.html',
  styleUrls: ['./welcome-wizard-key-indicator-page.component.scss']
})
export class WelcomeWizardKeyIndicatorPageComponent extends WizardPageComponent<WelcomeWizard> implements OnDestroy {

  key = 'key-indicator';

  KeyIndicatorType = KeyIndicatorType;

  constructor(
    private hitTrackingService: HitTrackingService,
    private userPreferencesService: UserPreferencesService
  ) {
    super();
    this.title = 'Welcome! Let\'s get started.';
    this.stepperText = 'Key Indicators';
    this.backButtonText = 'Back';
    this.closeButtonText = 'Close';
    this.doNotShowAgainCheckbox = 'Don\'t show again';
    this.headerText = 'Key Indicator Preferences';
    this.nextButtonText = 'Next';
  }

  onLoad(): Observable<any> {
    this.initForm();
    return super.onLoad();
  }


  onDonotShowAgainClick(): any {
    const parser = new UAParser(navigator.userAgent).getResult();
    let deviceType = parser.device.type;
    if (!deviceType) {
      deviceType = 'desktop';
    }
    const meta = this.buildTrackingMeta();
    const OSmetadata = this.hitTrackingService.getFirstTimeSetupMetadata();

    this.hitTrackingService.hitTheUserTracking(
      USER_TRACKING_SOURCES.FIRST_TIME_KEY_INDICATOR,
      { ...meta, ...OSmetadata },
      USER_TRACKING_ACTIONS.OPT_OUT_KEY_INDICATOR,
      USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.OPT_OUT_KEY_INDICATOR],
      false
    ).subscribe();
  }

  onDonotShowAgainUnchecked(): any {
    const parser = new UAParser(navigator.userAgent).getResult();
    let deviceType = parser.device.type;
    if (!deviceType) {
      deviceType = 'desktop';
    }
    const meta = this.buildTrackingMeta();
    const OSmetadata = this.hitTrackingService.getFirstTimeSetupMetadata();

    this.hitTrackingService.hitTheUserTracking(
      USER_TRACKING_SOURCES.FIRST_TIME_KEY_INDICATOR,
      { ...meta, ...OSmetadata },
      USER_TRACKING_ACTIONS.OPT_OUT_KEY_INDICATOR,
      USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.OPT_OUT_KEY_INDICATOR],
      false
    ).subscribe();
  }


  onClose(): Observable<null> {
    if (this.wizard.doNotShowAgainCheckboxChecked) {
      const request = _.cloneDeep(this.wizard.model.userPreferences);
      request.isWelcomeWizardComplete = true;
      this.userPreferencesService.updateOne(request)
        .pipe(map(() => null));
    }
    const formValue = this.form.getRawValue();
    const meta = this.buildTrackingMeta();
    const OSmetadata = this.hitTrackingService.getFirstTimeSetupMetadata();

    // 🔹 Track Close
    this.hitTrackingService.hitTheUserTracking(
      USER_TRACKING_SOURCES.FIRST_TIME_KEY_INDICATOR,
      {
        ...meta,
        ...OSmetadata,
        ...formValue
      },
      USER_TRACKING_ACTIONS.CLOSE_KEY_INDICATOR,
      USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.CLOSE_KEY_INDICATOR],
      false
    ).subscribe();


    return super.onClose();
  }


  onNext(): Observable<string> {
    const formValue = this.form.getRawValue();

    this.wizard.model.request.primaryKeyIndicator = formValue.primaryKeyIndicator;

    const meta = this.buildTrackingMeta();
    const OSmetadata = this.hitTrackingService.getFirstTimeSetupMetadata();

    // 🔹 Track Next (with form value)
    this.hitTrackingService.hitTheUserTracking(
      USER_TRACKING_SOURCES.FIRST_TIME_KEY_INDICATOR,
      {
        ...meta,
        ...OSmetadata,
        ...formValue,
        selectedPreferences: {
          primaryKeyIndicator: formValue.primaryKeyIndicator
        }
      },
      USER_TRACKING_ACTIONS.NEXT,
      USER_TRACKING_ACTION_DESCRIPTIONS.USER_TRACKING_ACTIONS_NEXT_KEY_INDICATORS,
      false
    ).subscribe();

    return of('map');
  }


  ngOnDestroy(): void {
    if (!this.wizard.model.userPreferences?.isWelcomeWizardComplete) {

    }
  }


  private initForm(): void {
    this.form = new UntypedFormGroup({
      primaryKeyIndicator: new UntypedFormControl(
        this.wizard.model.userPreferences.primaryKeyIndicator,
        [Validators.required]
      )
    });
  }

  private buildTrackingMeta(): any {
    return {
      time: new Date().toISOString()
    };
  }
}
